import h2TagStyles from "./H2Tag.module.css";

export function H2Tag({
  heading,
  link = true,
  id,
}: {
  heading: string;
  link?: boolean;
  id?: string;
}) {
  return (
    <h2 className={h2TagStyles.heading} id={id}>
      {heading}
    </h2>
  );
}
